<div class="ui modal" id="BettingSlip_Balance_Modal">
    <div class="ui grid">
        <div class="sixteen wide column" style="padding:6px">
            <button class="ui fluid button">
                <span tkey="Place_entire_balance"></span>
            </button>
        </div>
        <div class="thirteen wide column" style="padding:6px">
            <button class="ui fluid button">
                <span tkey="Pay_out_balance"></span>
            </button>
        </div>
        <div class="three wide column" style="padding:6px">
            <button class="circular ui icon button" (click)="Balance_Modal_Button_Info()">
                <i class="icon info"></i>
            </button>
        </div>
        <div class="sixteen wide column" style="padding:6px">
            <button class="ui fluid button" (click)="Balance_Modal_Button_Cancel()">
                <span tkey="Cancel"></span>
            </button>
        </div>
    </div>
</div>

<comp_bettingslip_balance_info_modal></comp_bettingslip_balance_info_modal>